/**
 * Hosted development environment (Cloudflare preview branch `dev`).
 *
 * Angular swaps `environment.ts` for this file on `staging` builds via the
 * `fileReplacements` entry in angular.json. Keep the shape identical to
 * `environment.ts`.
 *
 * This is a real deployed environment (track-dev.iotzen.app), so it is built
 * with production optimizations — only `apiBaseUrl` differs from prod.
 */
export const environment = {
  production: false,
  apiBaseUrl: 'https://dev.iotzen.app',
};
